import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import NavbarTwo from "../../Components/Navbar/navbarTwo";
import Footer from "../../Components/Footer";
import BottomNavbar from "../../Components/Navbar/bottomNavbar";

interface Article {
  id: number;
  title: string;
  slug: string;
  image: string;
  body: string;
  created_at: string;
}

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL!;

const BeritaPage: React.FC = () => {
  const [articles, setArticles] = useState<Article[]>([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    const fetchArticles = async () => {
      setLoading(true);
      try {
        const res = await fetch(`${API_BASE_URL}/api/articles?page=${page}`);
        const json = await res.json();

        setArticles(json.data || []);
        setLastPage(json.last_page || 1);
        setTotal(json.total || 0);
      } catch (error) {
        console.error("Gagal ambil artikel:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchArticles();
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [page]);

  const formatDate = (date: string) => {
    return new Date(date).toLocaleDateString("id-ID", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const truncateText = (text: string, max: number) => {
    return text.length > max ? text.slice(0, max) + "..." : text;
  };

  return (
    <>
      <NavbarTwo />

      <section className="bg-gray-100 py-24 md:py-28 font-signika">
        <div className="max-w-[1200px] mx-auto px-4 md:px-8">
          {/* HEADER */}
          <div className="flex justify-between items-center mb-5 pt-3 md:pt-8">
            <h1 className="text-2xl md:text-3xl font-bold">
              Kabar & <span className="text-primary2">Inspirasi</span>
            </h1>

            <div className="bg-primary2 text-white px-4 py-2 rounded-full text-sm">{total} Artikel</div>
          </div>

          {/* LOADING */}
          {loading && (
            <div className="flex justify-center items-center py-20 gap-2">
              <span className="w-3 h-3 bg-primary2 rounded-full animate-bounce" />
              <span className="w-3 h-3 bg-primary2 rounded-full animate-bounce" />
              <span className="w-3 h-3 bg-primary2 rounded-full animate-bounce" />
            </div>
          )}

          {/* CARD LIST */}
          <div className="space-y-6">
            {articles.map((article) => (
              <div key={article.id} className="bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden">
                <div className="flex flex-col md:flex-row">
                  {/* IMAGE */}
                  <div className="md:w-72 w-full h-52 md:h-52">
                    <img src={`${API_BASE_URL}/uploads/articles/${article.image}`} alt={article.title} className="w-full h-full object-cover" />
                  </div>

                  {/* CONTENT */}
                  <div className="flex flex-col justify-between p-5 flex-1">
                    <div>
                      <div className="flex items-center gap-3 mb-2">
                        <span className="text-xs font-semibold bg-primary2/10 text-primary2 px-3 py-1 rounded-full">BERITA</span>

                        <span className="text-sm text-gray-500">{formatDate(article.created_at)}</span>
                      </div>

                      <h2 className="text-lg md:text-xl font-bold text-gray-800 mb-3 hover:text-primary2 transition">{article.title}</h2>

                      <p className="text-gray-600 text-sm md:text-base leading-relaxed">{truncateText(article.body, 150)}</p>
                    </div>

                    <div className="mt-6 flex justify-end">
                      <Link to={`/berita/${article.slug}`} className="text-primary2 font-semibold hover:underline">
                        Baca Selengkapnya →
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* PAGINATION */}
          <div className="flex justify-end mt-12 gap-2 flex-wrap">
            {Array.from({ length: lastPage }, (_, i) => i + 1).map((num) => (
              <button key={num} onClick={() => setPage(num)} className={`w-10 h-10 rounded-full text-sm font-semibold transition ${page === num ? "bg-primary2 text-white shadow-lg" : "bg-white border hover:bg-gray-100"}`}>
                {num}
              </button>
            ))}
          </div>
        </div>
      </section>

      <Footer />
      <BottomNavbar />
    </>
  );
};

export default BeritaPage;
